<template>
	<div class="component-container">
		<!--bind ComputerAlert to isOpen data and register listener for the alert to be clicked-->
		<ComputerAlert v-bind:isOpen="isOpen" v-on:onClickComputerAlert="isOpen = true"></ComputerAlert>
		<div class="email" v-show="isOpen">
			<div class="vuebar-element" v-bar="{ preventParentScroll: true, useScrollbarPseudo: true}">
				<div class="vuebar-content">
					<div class="email-content">
						<div class="email-header">
							From: Shady Sam<br />
							To: {{getPlayerName}}<br />
							Date: {{formatedDate}}<br />
							Subject: {{email_data.email_subject}}
						</div>
						<div class="divider"></div>
						<div class="email-body">
							<div v-html="emailBody"></div>
							<div :class="performance" class="rewards">
								<label v-for="(reward, index) in rewardsAvailable" :key='index' class="reward">
									<input type="radio" :id="reward.title" :value="reward" v-model="selectedReward" />
									<img :src="reward.reward_image.url" />
									<span class="active-chip"><div>√</div></span>
								</label>
							</div>
							<div v-html="email_data.email_signature"></div>
						</div>
						<p class="error" v-for="error in errors" :key="error.id">{{ error }}</p>
						<Button class="startBtn" :action="closeEmail">{{email_data.email_close_button}}</Button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Button from '@/components/abstract/Button';
import ComputerAlert from '@/components/abstract/ComputerAlert';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';
import random from '@/mixins/random';
import tracking from '@/mixins/tracking';

export default {
	name: 'RewardEmail',
	mixins: [random, tracking, msEdgeImageSwap],
	data() {
		return {
			isOpen: false,
			selectedReward: null,
			errors: [],
		};
	},
	components: {
		Button,
		ComputerAlert,
	},
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
		email_data() {
			return this.$store.getters.getEmailByTypeAndLevel(this.$route.params.level, "Progress Report");
		},
		rewardsAvailable() {
			let rewards = this.shuffled(this.email_data.rewards_available);
			rewards = rewards.slice(0, 3);
			return rewards;
		},
		getPlayerName() {
			return this.$store.state.playerName;
		},
		formatedDate() {
			return this.$store.state.todaysDate;
		},
		formattedMoney() {
			return this.formatMoney(this.$store.state.totalMoney);
		},
		getNumCustomers() {
			return this.$store.state.scores.length;
		},
		performance() {
			const score = this.$store.state.score;
			if (score < 1.67) {
				return 'good';
			} else if (score > 2.34) {
				return 'bad';
			}
			return 'medium';
		},
		emailBody() {
			let s = this.email_data.email_body_copy;
			let rewardMsg = "";
			if (this.performance === 'good') {
				rewardMsg = this.randomValue(this.email_data.good_copy);
			} else if (this.performance === 'medium') {
				rewardMsg = this.randomValue(this.email_data.medium_copy);
			} else {
				rewardMsg = this.randomValue(this.email_data.bad_copy);
			}
			s = s.replace("{{reward messaging}}", rewardMsg.copy_option);
			s = s.replace(new RegExp("{{Name}}", 'g'), this.getPlayerName);
			s = s.replace(new RegExp("{{userTotal}}", 'g'), this.formattedMoney);
			s = s.replace(new RegExp("{{numCustomers}}", 'g'), this.getNumCustomers);
			return s;
		},
	},
	methods: {
		formatMoney(amt) {
			return amt.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
		closeEmail() {
			if (this.selectedReward != null || this.performance === 'bad') {
				this.$store.commit('setDeskItem', this.selectedReward);
				if (this.selectedReward != null) {
					this.trackPageview(`reward-${this.selectedReward.title}`, `/level-${this.$store.state.level}/reward/${this.selectedReward.title}`);
				} else {
					this.trackPageview(`reward-none`, `/level-${this.$store.state.level}/reward/none`);
				}
				this.$router.push({ name: 'Scene', params: { level: this.$store.state.level, scene: this.$store.state.scene } });
			} else {
				this.errors = [];
				this.errors.push('Please select your reward.');
			}
		},
	},
	mounted() {
		this.swapEdgeImages();
	},
};
</script>

<style lang="scss" scoped>
	// global email styles are in base-classes
	.rewards{
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
		&.bad > .reward{ // all disabled
			opacity: .5;
			pointer-events: none;
		}
		&.medium > .reward:nth-child(odd){
			opacity: .5;
			pointer-events: none;
		}
		.reward{
			width: 100%;
			max-width: 100px;
			height: auto;
			padding: 0px;
			margin: 20px 10px 20px 10px;
			color: black;
			flex: 0 1 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			cursor: pointer;
			& img{
				width: 100%;
				height: auto;
				cursor: pointer;
			}
			& .active-chip{
				width: 0;
				height: 0;
				border-top: 40px solid $green;
				border-left: 40px solid transparent;
				position: absolute;
				top: 0;
				right: 0;
				display: none;
				color: white;
				& div{
					position: absolute;
					top: -37px;
					right: 4px;
				}
			}
			& > input {
				visibility: hidden;
				position: absolute;
			}
			& > input + img {
				cursor: pointer;
				border: 5px solid $gray-light;
			}
			& > input:checked + img {
				border-color: $green;
			}
			& > input:checked ~ .active-chip {
						display: block;
			}
			&:hover > img{
				border-color: $green;
			}
			p{
				position: absolute;
				top: 0;
				margin-top: 0;
				width: 100%;
				text-align: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/emails/RewardEmail.vue